import { useAuth } from '@hourly/contexts/AuthContext';
import { useEffect, useRef, useState } from 'react';
import PubnubClient from '~/routes/_shared/events/clients/pubnubClient';
import eventGateway from '~/routes/_shared/events/eventGateway';

export default function useEventGateway() {
  const { sessionState } = useAuth();
  const [pubnubClient, setPubnubClient] = useState<PubnubClient | null>(null);
  const alreadyStarted = useRef(false);
  useEffect(() => {
    const createPubnub = async () => {
      if (!sessionState.userId || alreadyStarted.current) {
        return;
      }
      alreadyStarted.current = true;
      const pubnub = new PubnubClient(sessionState.userId);
      await pubnub.start();

      setPubnubClient(pubnub);
    };
    createPubnub();
  }, [sessionState.userId]);

  useEffect(() => {
    if (!pubnubClient) {
      return;
    }
    const removeSource = eventGateway.addEventSource(pubnubClient);
    eventGateway.start();
    return () => {
      removeSource();
    };
  }, [pubnubClient, sessionState.userId]);
}
